export default function pluralize(count, strings) {
  if (count === 1) return strings.one || strings.other;

  return strings.other.replace(/\[count\]/, count);
}
